"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      id: '',
      dialogVisible: false,
      ruleForm: {
        num1: '',
        num2: '',
        bgPic: ''
      },
      rules: {
        num1: [{
          required: false
        }],
        num2: [{
          required: false
        }],
        bgPic: [{
          required: false
        }]
      }
    };
  },
  methods: {
    delPic: function delPic() {
      this.ruleForm.bgPic = '';
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              file = _ref.file;
              _context.p = 1;
              _context.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context.v;
              // console.log(pictureUrl, '-------------')
              this.ruleForm.bgPic = pictureUrl;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log('error ->', _t);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleFileUpload(_x) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    open: function open(data) {
      var _this = this;
      this.id = data.id;
      (0, _customPage.moduleDetail)({
        moduleId: data.id
      }).then(function (res) {
        if (res.data && res.data.earningsReport) {
          _this.ruleForm.bgPic = res.data.earningsReport.defaultPic;
          _this.ruleForm.num1 = res.data.earningsReport.minEarnings;
          _this.ruleForm.num2 = res.data.earningsReport.maxEarnings;
        }
      });
      this.dialogVisible = true;
    },
    onClose: function onClose() {
      this.ruleForm = {
        num1: '',
        num2: '',
        bgPic: ''
      };
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _customPage.saveOrUpdateBanner)({
            moduleId: _this2.id,
            earningsReport: {
              defaultPic: _this2.ruleForm.bgPic,
              maxEarnings: _this2.ruleForm.num2 >= _this2.ruleForm.num1 ? _this2.ruleForm.num2 : _this2.ruleForm.num1,
              minEarnings: _this2.ruleForm.num1 < _this2.ruleForm.num2 ? _this2.ruleForm.num1 : _this2.ruleForm.num2
            }
          }).then(function (res) {
            if (res.data) {
              _this2.$notify.success({
                title: '温馨提示',
                message: '操作成功'
              });

              // this.$emit('refresh', this.type)
              _this2.onClose();
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};